/* Algolia Search */
const algoliasearch = require("algoliasearch/lite");
const instantsearch = require("instantsearch.js").default;
import { searchBox, pagination, refinementList } from "instantsearch.js/es/widgets";
import { highlight } from "instantsearch.js/es/helpers";
import { connectHits } from "instantsearch.js/es/connectors";
import { enhanceTopicNames, isDocsTopic } from "./util/search.js";

const INDEX_NAME = "Test";
const BASE_URL = "https://curity.io";

export const initSearch = () => {
    if (document.querySelector(".ais-InstantSearch")) {
        if (navigator.onLine) {
            const searchClient = algoliasearch("NUFU8SFAHN", "a0d405f1be45d599869c72a0cf306e66");

            // Get URL search parameter
            var url_string =
                window.location.protocol +
                "//" +
                window.location.host +
                "/" +
                window.location.pathname +
                window.location.search;
            const url = new URL(url_string);
            const q = url.searchParams.get("q");

            document.querySelector("#search-results").style.display = "none";
            document.querySelector("h1").style.display = "none";
            document.querySelector(".ais-InstantSearch").style.display = "block";
            document.querySelector("h1.ais-InstantSearch-h1").style.display = "block";

            const hitsContainer = document.querySelector("#hits");
            const paginationContainer = document.querySelector("#pagination");
            const refinementsContainer = document.querySelector(".search-refinements-container");

            if (document.querySelector("#searchbox")) {
                const search = instantsearch({
                    searchFunction(helper) {
                        if (helper.state.query === "") {
                            hitsContainer.style.display = "none";
                            paginationContainer.style.display = "none";
                            refinementsContainer.style.display = "none";
                        } else {
                            hitsContainer.style.display = "";
                            paginationContainer.style.display = "";
                            refinementsContainer.style.display = "";
                        }

                        helper.search();
                    },
                    searchClient: searchClient,
                    indexName: INDEX_NAME,
                    routing: {
                        stateMapping: {
                            stateToRoute: function (uiState) {
                                return {
                                    q: uiState[`${INDEX_NAME}`].query,
                                };
                            },
                            routeToState: function (routeState) {
                                return {
                                    Test: {
                                        query: routeState.q,
                                    },
                                };
                            },
                        },
                    },
                });

                // Custom hit render function
                const renderHits = (renderOptions, isFirstRender) => {
                    const { hits, results } = renderOptions;

                    // Make search hit URLs work locally when using `make livehtml`
                    const isLocalhost = Boolean(
                        window.location.hostname === 'localhost' ||
                        window.location.hostname === '[::1]' ||
                        window.location.hostname.startsWith('127')
                    );

                    const getDocsUrl = (url) => isLocalhost ? url.replace('/docs/idsvr/latest/', '/') : url

                    const getHitSlug = (item) => {
                        // Identity Server Docs
                        if (item.slug) {
                            if (item.slug.includes("idsvr")) {
                                return getDocsUrl(item.slug);
                            } else if (item.slug.includes("blog")) {
                                // Blog
                                return `${BASE_URL}/${item.slug}/`;
                            } else if (item.topic === 'product') {
                                // Product
                                return `${BASE_URL}/product/${item.slug}/`;
                            } else if (item.area !== null) {
                                // Articles
                                const articleSlug = item.slug.split("/");
                                return `${BASE_URL}/resources/learn/${articleSlug[articleSlug.length - 1]}`;
                            } else {
                                return `${BASE_URL}/${item.slug}`;
                            }
                        } else if (item.contentfulType) {
                            // Contentful
                            switch (item.contentfulType) {
                                case "Webinars":
                                    return `${BASE_URL}/resources/webinars/${item.permalink}/`;
                                case "White Papers And Guides":
                                    return `${BASE_URL}/resources/whitepapers/${item.permalink}/`;
                                case "Documents":
                                    return `${BASE_URL}/resources/documents/${item.permalink}/`;
                                case "Video":
                                    return `${BASE_URL}/resources/videos/${item.permalink}/`;
                                default:
                                    return "/";
                            }
                        }
                    };

                    // Show hit type
                    const getHitType = (item) => {
                        if (isDocsTopic(item.topic)) {
                            return `<span class="primary mr1">Docs / <span class="bright">${item.topic}</span></span>`;
                        } else if (item.contentfulType) {
                            return `<span class="bright">Resources / ${item.contentfulType}</span>`;
                        } else if (item.pagegroup !== null && item.pagegroup !== undefined) {
                            return `<span class="bright">Resources / </span><span class="primary">${item.pagegroup}</span>`;
                        } else if (item.slug.includes("blog")) {
                            return `<span class="bright">Blog</span>`;
                        } else {
                            return `<span class="bright">Resources ${
                                item.topic !== null && item.topic !== undefined ? `/ ${item.topic}` : ""
                            }</span>`;
                        }
                    };

                    // Display empty state UI
                    if (results) {
                        if (results.nbHits === 0) {
                            document.querySelector(".ais-InstantSearch-emptystate").innerHTML = `
                    <p class="center">
                    <svg class="w-8 h-8 block mx-auto" xmlns="http://www.w3.org/2000/svg" data-name="Lager 1" viewBox="0 0 256 256"><path fill="none" stroke="#c0c4cf" stroke-linecap="round" stroke-linejoin="round" stroke-width="14.09" d="M163.92 108.07a69.26 69.26 0 1 1-69.26-69.26 69 69 0 0 1 69.26 69.26ZM204.82 217.42l-60.52-61.05"/><path fill="#626c87" d="M99.94 118.58H85L82 129H71.88l16.34-49.89H97L113 129h-10.15Zm-12.61-8.19h10.35L92.57 92Z" opacity=".44"/><g fill="none" stroke="#e0e2e7" stroke-linecap="round" stroke-linejoin="round" stroke-width="10.56" opacity=".41"><path d="M188.07 65.57h53.01M188.07 103.72h26.33M188.07 141.87h26.33"/></g></svg>
                    Sorry, no results found for &ldquo; ${results.query}&rdquo;
                    </p>
                    `;
                            document.querySelector(".ais-InstantSearch-emptystate").classList.remove("hide");
                            paginationContainer.style.display = "none";
                        } else {
                            document.querySelector(".ais-InstantSearch-emptystate").classList.add("hide");
                        }
                    }

                    // Display hits
                    document.querySelector("#hits").innerHTML = `
                ${hits
                    .map(
                        (item) =>
                            `
                                <a href=${getHitSlug(item)} class="ais-Hits-item p2">
                                    <div class="sm-flex">
                                        <div class="p2 flex-auto">
                                            <span class="ais-Hits-item-kind bright block">${getHitType(item)}</span>
                                            <h1 class="h3">
                                                ${highlight({ attribute: "title", hit: item })}
                                            </h1>
                                            <p class="hit-description">
                                            ${
                                                item.description
                                                    ? highlight({
                                                          attribute: "description",
                                                          hit: item,
                                                      })
                                                    : ""
                                            }
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            `
                    )
                    .join("")}

            `;
                };

                // Use the connected hit widget
                const customHits = connectHits(renderHits);

                // Define our widgets
                search.addWidgets([
                    searchBox({
                        container: "#searchbox",
                        placeholder: "Search Docs",
                        autofocus: true,
                        searchAsYouType: true,
                        searchParameters: {
                            query: q,
                        },
                    }),
                    customHits(),
                    pagination({
                        container: "#pagination",
                    }),
                    refinementList({
                        container: "#refinements",
                        attribute: "topic",
                        limit: 100,
                        transformItems(items) {
                            return items

                                .filter(
                                    (item) =>
                                        item.label !== "product" &&
                                        item.label !== "solutions" &&
                                        item.label !== "company"
                                )
                                .filter((item) => !isDocsTopic(item.label))
                                .sort((a, b) => a.label.localeCompare(b.label))
                                .map((item) => ({
                                    ...item,
                                    topicname: enhanceTopicNames(item.label),
                                }));
                        },
                        templates: {
                            item: `
                    <label class="ais-RefinementList-label"> <input type="checkbox" {{#isRefined}}checked{{/isRefined}} class="ais-RefinementList-checkbox" value={{label}}>
                        <span class="ais-RefinementList-labelText">{{topicname}}</span>
                        <span class="ais-RefinementList-count">{{count}}</span>
                    </label>
                    `,
                        },
                    }),
                    refinementList({
                        container: "#refinements-idsvr",
                        attribute: "topic",
                        limit: 100,
                        transformItems(items) {
                            return items
                                .filter((item) => isDocsTopic(item.label))
                                .sort((a, b) => a.label.localeCompare(b.label))
                                .map((item) => ({
                                    ...item,
                                    topicname: enhanceTopicNames(item.label),
                                }));
                        },
                        templates: {
                            item: `
                    <label class="ais-RefinementList-label"> <input type="checkbox" {{#isRefined}}checked{{/isRefined}} class="ais-RefinementList-checkbox" value={{label}}>
                        <span class="ais-RefinementList-labelText">{{topicname}}</span>
                        <span class="ais-RefinementList-count">{{count}}</span>
                    </label>
                    `,
                        },
                    }),
                ]);

                search.start();
            }
        } else {
            document.querySelector(".ais-InstantSearch").style.display = "none";
        }
    }
};
